module.exports = __webpack_public_path__ + "59f7575a85a1e630bd1358fffa68237d.jpg";